import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import permissionRoutes from '../../../components/permission/permissionRoutes';

const update = createAsyncThunk(
  'thunk/permission/update',
  async (arg, thunkAPI) => {
    const response = await apiFetch(permissionRoutes.api.generate.update(arg?.id), {
      body: arg?.data,
      method: 'POST',
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default update;
